import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { AccountPaymentService } from '@ztarmobile/zwp-service-backend';
import { AddressesAutocompleteService } from '@ztarmobile/zwp-service-backend-v2';
import { Observable, catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddressAutoCompleteHelperService {
  constructor(private placesAutoCompleteService: AddressesAutocompleteService) { }

  getAddressValues(placeInfo: any, displayedModel: any = null, searchTerms: string = '') {
    let address: any = {
      name: displayedModel?.name || displayedModel?.alias || '',
      address1: placeInfo.address1,
      address2: placeInfo.address2,
      state: placeInfo.state ? placeInfo.state.toUpperCase() : '',
      city: placeInfo.city,
      country: placeInfo.country || 'United States',
      postalCode: placeInfo.postalCode,
    };

    if (displayedModel?.id) {
      address.id = displayedModel.id;
      address.isDefault = displayedModel.isDefault;
    }

    if (searchTerms && typeof searchTerms === 'string') {
      if (!searchTerms.includes(placeInfo.address1)) {
        address.address1 = searchTerms.trim();
      }
    }

    if (address.address1) {
      address.address1 = AccountPaymentService.shortenAddress(address.address1, 30);
    }

    // Clean out undefined values
    Object.keys(address).forEach((key) => {
      if (address[key] === undefined || address[key] === null) {
        delete address[key];
      }
    });

    return { ...address };
  }
  addressObjectValidator(control: AbstractControl) {
    const value = control.value;
    // Must be a selected object with place_id or main_text

    if (!!value && !control.dirty) {
      return null; //valid prefilled value
    }
    
    if (typeof value === 'object' && value !== null && 'main_text' in value) {
      return null; //valid (selected from the list)
    }
    return { invalidAddress: true }; //invalid
  }
  addressDetails(address: any, displayedModel: any, searchText: string): Observable<{ formatted: string; model: any }> {
    const sessionId = sessionStorage.getItem('placesSessionToken');

    if (!address?.place_id) {
      return throwError(() => new Error(`Invalid address or missing place_id.`));
    }

    return this.placesAutoCompleteService.findDetailedAddressFields(address.place_id, sessionId).pipe(
      map((place) => {
        const model = this.getAddressValues(place, displayedModel, searchText);
        const formatted = `${model?.address1}, ${model?.city}, ${model?.state} ${model?.postalCode ?? ''}`;
        return { formatted, model };
      }),
      catchError((err) => {
        console.warn(`Failed to fetch details for place_id: ${address.place_id}`, err);
        return throwError(() => err);
      })
    );
  }
}
